import { api } from "@/lib/api";

let cache = null;
let promise = null;

export function getChampions() {
  if (cache) return Promise.resolve(cache);
  if (!promise) {
    promise = api.get("/players/champions/list")
      .then(({ data }) => { cache = data; return data; })
      .catch(() => { promise = null; return {}; });
  }
  return promise;
}

export function bustChampionsCache() {
  cache = null;
  promise = null;
}
